module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12SdPGM/tc-custom/9781446358641.jpg?1728851607153",
      "alt": "This image is the cover for the book Contemporary Cake Decorating Bible: Stenciling"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Contemporary Cake Decorating Bible: Stenciling\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Stenciling is an extremely effective way to add impressive decorations to your cakes and cookies quickly. For the best and most satisfying results, Lindy Smith recommends using laser-cut culinary stencils made from durable food-grade plastic. How you choose to add a stenciled pattern will depend on the effect you wish to achieve and the size of the item to be stencilled. This chapter, taken from "), _c('i', [_vm._v("The Contemporary Cake Decorating Bible")]), _vm._v(", shows you various techniques using both edible dusts and royal icing; it also shows you how to make your own stencils and some possible other uses.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lindy Smith\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    David & Charles\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0